import { render, staticRenderFns } from "./xiyatu.vue?vue&type=template&id=ed16e9ca&scoped=true"
import script from "./xiyatu.vue?vue&type=script&lang=js"
export * from "./xiyatu.vue?vue&type=script&lang=js"
import style0 from "./xiyatu.vue?vue&type=style&index=0&id=ed16e9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed16e9ca",
  null
  
)

export default component.exports